package store

/**
 *
 */
class NotLoggedInException : Exception("Not logged in")
